<template>  
  <nav>
			<div class="wrapper">
				<div class="wrap">
					<div class="logo">
						<img src="@/assets/images/logo.png">
					</div>
					<ul class="nav">
						<li v-for="(item,index) in navs" :key="index" @click="$router.push({'path':item.path})" :class="$route.path==item.path?'active':''">{{item.name}}</li>
					</ul>
                    <!-- <div class="lang" @click="languageChange"><img src="@/assets/images/language.svg" width="24"><p>{{$i18n.locale=='zh_CN'?'中文':'EN'}}</p></div> -->
                     <div class="btn-openaccount">Open Account</div>
				</div>
				
			</div>
		</nav>
</template>

<script>
import { useRoute } from 'vue-router';
	import { toRefs, reactive } from "vue";
	import { useStore } from "vuex";
	import { useI18n } from 'vue-i18n';
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  setup(){
    const $i18n = useI18n();
    const {t} = useI18n();
    const $store = useStore();
    const $route = useRoute();
    const state = reactive({
        language:'zh_CN',
        langObj:{},
        platform:'',
        navs:[
            {
                name:"Home",
                path:"/"
            },
            {
                name:"Trading",
                path:"/trading"
            },
            {
                name:"Platform",
                path:"/platform"
            },
            {
                name:"About",
                path:"/about"
            }
        ]
    });

    const languageChange = ()=>{
        let targetLang = '';
        if(state.language=='zh_CN'){
            targetLang = 'en_US';
        }else{
            targetLang = 'zh_CN';
        }
        state.language = targetLang;
        $i18n.locale.value = state.language;
    }

    return {
        ...toRefs(state),
        languageChange
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
nav{			
    height: 72px;
    width: 100%;
    position: fixed;
    z-index: 999;
    top: 0;
        background-color: #fff;
            box-shadow: 0 2px 18px rgba($color: #999, $alpha: .1);
        .wrapper{
            padding: 0 10px;
            color: #000;
            height: 100%;
            
            .wrap{				
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 100%;
                .logo{
                    height: 40px;
                    width: 200px;
                    img{
                        height: 100%;
                    }
                }
                .nav{
                    width: 50%;
                    cursor: pointer;
                    display: flex;
                    margin-left: 100px;
                    justify-content: flex-start;
                    align-items: center;
                    font-size: 16px;
                    font-weight: bold;
                    li{
                        margin-right: 60px;
                        &.active{
                            color: #22823A;
                        }
                    }
                }
            }
            .lang{
                line-height: 30px;
                //border: 1px solid #43e39a;
                border-radius: 5px;
                padding: 0 10px;
                cursor: pointer;
                img{
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 5px;
                }
                p{
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 15px;
                }
            }
            .btn-openaccount{
                background-color: #22823A;
                padding: 12px 30px;
                border-radius: 30px;
                color: #fff;
                font-size: 16px;
                cursor: pointer;
                transition: background-color .3s;
                &:hover{
                    background-color: #e55a3f;
                }
            }
        }
    }
</style>
